import React, { useEffect, useMemo, useState } from "react";
import { Refresh, Security } from "@mui/icons-material";
import { fetchAuditLogs } from "../services/owdedApi";
import { dateOnly } from "./format";
import { EmptyState, Pagination } from "./ui";
import { currentMonthRange, paginateRows, PAGE_SIZE, rangeForMode } from "./listUtils";

function AuditPage() {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [periodMode, setPeriodMode] = useState("MONTH");
  const [period, setPeriod] = useState(currentMonthRange());
  const [page, setPage] = useState(1);
  const [notice, setNotice] = useState("");
  const activeRange = useMemo(
    () => rangeForMode(periodMode, period.start_date, period.end_date),
    [periodMode, period.start_date, period.end_date]
  );

  const load = () => {
    fetchAuditLogs(activeRange).then(setLogs).catch(() => setNotice("Impossible de charger l'audit."));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeRange.start_date, activeRange.end_date]);

  const filtered = useMemo(() => {
    const term = search.toLowerCase();
    return logs.filter((log) =>
      [log.user_name, log.action, log.entity, log.entity_id, log.ip_address]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(term))
    );
  }, [logs, search]);

  const pagination = useMemo(() => paginateRows(filtered, page, PAGE_SIZE), [filtered, page]);

  useEffect(() => {
    setPage(1);
  }, [search, activeRange.start_date, activeRange.end_date]);

  return (
    <main className="page-content management-page">
      <div className="page-head">
        <div>
          <h1>Controle interne</h1>
          <p>Traçabilite complete des connexions, creations, modifications, validations et suppressions logiques.</p>
        </div>
      </div>
      {notice && <p className="notice">{notice}</p>}

      <section className="panel data-panel">
        <div className="table-toolbar">
          <input placeholder="Recherche avancee..." value={search} onChange={(event) => setSearch(event.target.value)} />
          <div className="period-controls">
            <select value={periodMode} onChange={(event) => setPeriodMode(event.target.value)}>
              <option value="DAY">Jour</option>
              <option value="WEEK">Semaine</option>
              <option value="MONTH">Mois</option>
              <option value="PERIOD">Periode</option>
            </select>
            {periodMode === "PERIOD" && (
              <>
                <input type="date" value={period.start_date} onChange={(event) => setPeriod((current) => ({ ...current, start_date: event.target.value }))} />
                <input type="date" value={period.end_date} onChange={(event) => setPeriod((current) => ({ ...current, end_date: event.target.value }))} />
              </>
            )}
          </div>
          <button className="ghost-btn" type="button" onClick={load}><Refresh /> Actualiser</button>
          <h2 className="section-title"><Security /> Journal d'audit</h2>
        </div>
        {filtered.length ? (
          <table className="data-table">
            <thead><tr><th>Date</th><th>Utilisateur</th><th>Action</th><th>Entite</th><th>ID</th><th>Apres operation</th><th>IP</th></tr></thead>
            <tbody>{pagination.rows.map((log) => (
              <tr key={log.id}>
                <td>{dateOnly(log.created_at)}</td>
                <td>{log.user_name || "Systeme"}</td>
                <td><span className="status-pill is-warning">{log.action}</span></td>
                <td>{log.entity}</td>
                <td>{log.entity_id || "-"}</td>
                <td><div className="audit-json">{log.after_data ? JSON.stringify(log.after_data) : "-"}</div></td>
                <td>{log.ip_address || "-"}</td>
              </tr>
            ))}</tbody>
          </table>
        ) : <EmptyState />}
        <Pagination
          page={pagination.safePage}
          totalPages={pagination.totalPages}
          totalItems={filtered.length}
          from={pagination.from}
          to={pagination.to}
          onPageChange={setPage}
        />
      </section>
    </main>
  );
}

export default AuditPage;
